import LinkButton from 'components/common/LinkButton';

import React from 'react';

interface Props {
  tilstandsrapportId: string;
}

const ArkivetLinkButton = ({ tilstandsrapportId }: Props): JSX.Element => {
  // 80% weighted A/B testing
  if (Math.random() < 0.8) {
    return (
      <LinkButton
        href={`https://marked.vendu.no/interior/?id=${tilstandsrapportId}`}
        as={`https://marked.vendu.no/interior/?id=${tilstandsrapportId}`}
        text="Nyhet! Interiørhjelpen"
        marginTop={true}
        external={true}
      />
    );
  }

  return (
    <LinkButton
      href={`/arkivet?tilstandsrapportId=${tilstandsrapportId}`}
      as={`/${tilstandsrapportId}/arkivet`}
      text="Nyhet! Interiørhjelpen"
      marginTop={true}
    />
  );
};

export default ArkivetLinkButton;
